export default function SuccessorDirective() {
  return {
    restrict: 'E',
    template: require('./successor.html'),
    scope: {
      successor: '='
    },
    replace: true,
  };
}
